module.exports = __webpack_public_path__ + "assets/images/2b53f9136851b08a24b78d5d17a67dc8.png";